import { Lock } from "lucide-react";
import { Checkbox } from "../../ui/checkbox";
import { Grid, SubHeading, TextAreaField, TextField } from "../Fields";
import { useWizard } from "../WizardContext";

const KEYS = ["address", "pin", "whatsapp", "phone", "email"];

function AddressFields({ prefix, disabled }) {
  const num = { inputMode: "numeric", disabled };
  return (
    <>
      <TextAreaField section="private" name={`${prefix}_address`} label="Address" required={!disabled} disabled={disabled} className="sm:col-span-2" rows={2} />
      <TextField section="private" name={`${prefix}_pin`} label="PIN code" required={!disabled} maxLength={6} placeholder="6 digits" {...num} />
      <TextField section="private" name={`${prefix}_phone`} label="Phone number" required={prefix === "present"} maxLength={10} placeholder="10-digit mobile" {...num} />
      <TextField section="private" name={`${prefix}_whatsapp`} label="WhatsApp number" maxLength={10} placeholder="10-digit mobile" {...num} />
      <TextField section="private" name={`${prefix}_email`} label="Email" type="email" disabled={disabled} />
    </>
  );
}

export default function StepContact() {
  const { data, set } = useWizard();
  const same = data.private.same_as_present;
  const toggle = (checked) => {
    set("private", "same_as_present", checked);
    if (checked) KEYS.forEach((k) => set("private", `permanent_${k}`, data.private[`present_${k}`]));
  };
  return (
    <Grid>
      <p className="col-span-full flex items-center gap-2 rounded-lg bg-[#F5E6BA]/50 px-3 py-2 text-xs text-[#4A000E]">
        <Lock className="h-3.5 w-3.5" /> Contact details are private and never shown to other members.
      </p>
      <SubHeading>Present address</SubHeading>
      <AddressFields prefix="present" />
      <SubHeading>Permanent address</SubHeading>
      <label className="col-span-full flex cursor-pointer items-center gap-2.5 text-sm font-medium text-[#2C2424]">
        <Checkbox checked={same} onCheckedChange={(v) => toggle(v === true)} data-testid="field-private-same_as_present" />
        Same as present address
      </label>
      {!same && <AddressFields prefix="permanent" />}
    </Grid>
  );
}
